import { Injectable } from '@angular/core';

import packageJson from 'package.json';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AppVersionInfoService {
  static ENV_NAME_PROD = 'Prod';

  versionNumber: string = packageJson.version;
  buildNumber: string = packageJson.buildNumber;
  envName = `${environment.envName}`;

  constructor() {}

  getVersionInfo(): string {
    return this._buildVersionInfo();
  }

  /**
   * Build a string to show "App Version" related info.
   *
   * NOTES:
   * - Format: `Version: {version_name}-{build_number} | {env_name}`
   * - If the `env` is on `PROD`, no need to show the `env_name`.
   */
  private _buildVersionInfo() {
    // Build the "version" related info first.
    let versionInfo = this.buildNumber
      ? `${this.versionNumber}-${this.buildNumber}`
      : `${this.versionNumber}`;

    // Check if need to show "env_name"
    if (this.envName !== AppVersionInfoService.ENV_NAME_PROD) {
      versionInfo = `${versionInfo} | ${this.envName}`;
    }

    return versionInfo;
  }
}
